export const userInfo = (state) => {
  return state.userInfo
}
export const shopCartNum = (state) => {
  return state.shopCartNum
}
export const showSearch = (state) =>{
  return state.showSearch
}
export const registerId = (state) => {
  return state.registerId
}
export const linkSrc = (state) =>{
  return state.linkSrc
}
export const avatar = (state) =>{
  return state.avatar
}
export const enterTime = (state) =>{
  return state.enterTime
}
export const leaveTime = (state) =>{
  return state.leaveTime
}
export const keyword = (state) =>{
  return state.keyword
}



// WEBPACK FOOTER //
// ./src/store/getters.js